import React, { useEffect, useState, useRef } from "react";
import {
  Table,
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
  Button,
  Input,
  FormGroup,
  Label,
} from "reactstrap";
import { useParams } from "react-router-dom";
import axiosInstance from "../../Request";
import { toast } from "react-toastify";
import { URL } from "../../api";
import getPrivilegeList from "../../PrivilegeList";

const PaymentHistory = () => {
  const privilegeList = getPrivilegeList();
  const { cid, lid } = useParams();
  const [customerDetails, setCustomerDetails] = useState([]);
  const [expandedRowId, setExpandedRowId] = useState(null);
  const [adjustmentData, setAdjustmentData] = useState({});
  const [commentModal, setCommentModal] = useState(false);
  const [commentType, setCommentType] = useState(""); // "extra" or "rollback"
  const [selectedPayment, setSelectedPayment] = useState(null);
  const [userComment, setUserComment] = useState("");
  const [refundModal, setRefundModal] = useState(false);
const [refundAmount, setRefundAmount] = useState("");
const [selectedRefundItem, setSelectedRefundItem] = useState(null);
const [refundLoading, setRefundLoading] = useState(false);
  const isMounted = useRef(true);


  // --- PAGINATION STATES ---
  const [currentPage, setCurrentPage] = useState(1);
  const rowsPerPage = 10;

  const formatDateTime = (dateTime) => {
  if (!dateTime) return "N/A";
  try {
    const date = new Date(dateTime);
    const pad = (n) => n.toString().padStart(2, "0");

    const year = date.getFullYear();
    const month = pad(date.getMonth() + 1);
    const day = pad(date.getDate());
    const hours = pad(date.getHours());
    const minutes = pad(date.getMinutes());
    const seconds = pad(date.getSeconds());

    return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
  } catch {
    return "Invalid Date";
  }
};


  useEffect(() => {
    return () => {
      isMounted.current = false;
    };
  }, []);

  const fetchCustomerDetails = async () => {
    try {
      const res = await axiosInstance.get(
        `${URL.PAYMENT_HISTORY}?customer_id=${cid}&lead_id=${lid}`
      );
      if (isMounted.current) {
        const data = Array.isArray(res.data) ? res.data : [];
        const sorted = [...data].sort((a, b) => a.payment_id - b.payment_id);
        setCustomerDetails(sorted);
      }
    } catch (err) {
      console.error("Error loading payments:", err);
    }
  };

  useEffect(() => {
    fetchCustomerDetails();
  }, [cid, lid]);

  // --- PAGINATION LOGIC ---
  const indexOfLastRow = currentPage * rowsPerPage;
  const indexOfFirstRow = indexOfLastRow - rowsPerPage;
  const currentRows = customerDetails.slice(indexOfFirstRow, indexOfLastRow);
  const totalPages = Math.ceil(customerDetails.length / rowsPerPage);

  const toggleRow = async (paymentId) => {
    const isExpanded = expandedRowId === paymentId;
    if (!isExpanded && !adjustmentData[paymentId]) {
      try {
        const res = await axiosInstance.get(
          `${URL.AMORT_ADJUSTMENT_FIP}?customerId=${cid}&paymentId=${paymentId}`
        );
        setAdjustmentData((prev) => ({ ...prev, [paymentId]: res.data }));
      } catch {
        setAdjustmentData((prev) => ({
          ...prev,
          [paymentId]: [{ message: "No adjustment found" }],
        }));
      }
    }
    setExpandedRowId(isExpanded ? null : paymentId);
  };

  const openCommentModal = (type, payment) => {
    setCommentType(type);
    setSelectedPayment(payment);
    setUserComment("");
    setCommentModal(true);
  };

  const handleCommentSubmit = async () => {
    if (!selectedPayment || !userComment.trim()) return;

    const payload = {
      customerId: parseInt(cid),
      // leadId: parseInt(lid),
      paymentId: selectedPayment.payment_id,
      comment: userComment,
      commentBy: parseInt(localStorage.getItem("user_id")),
    };

    try {
      const url =
        commentType === "extra"
          //  ? "http://localhost:8080/payment_consent/apply_extra"
          // : "http://localhost:8080/payment_consent/rollback";

           ? URL.PAYMENT_EXTRA
      : URL.PAYMENT_ROLLBACK;

      const res = await axiosInstance.post(url, payload);

      if (res.data?.message) toast.success(res.data.message);
      fetchCustomerDetails();
    } catch (err) {
      toast.error(err.response?.data?.message || "Action failed");
    } finally {
      setCommentModal(false);
      setSelectedPayment(null);
      setUserComment("");
    }
  };
const openRefundModal = (item) => {
  setSelectedRefundItem(item);
  setRefundAmount(item.extra_amount);
  setRefundModal(true);
};


const handleRefundSubmit = async () => {
  if (refundLoading) return;
  try {
    if (!selectedRefundItem) return;
    setRefundLoading(true);

    const applicationId = `SC${cid}${lid}`;

    const params = new URLSearchParams();
    params.append("applicationId", applicationId);
    params.append("tranId", selectedRefundItem.tran_id);
    params.append("amount", Number(refundAmount));
    params.append("partial", 0);
    const res = await axiosInstance.post(
      URL.REFUND_EXTRA_PAYMENT,
      params,
      {
        headers: {
          "Content-Type": "application/x-www-form-urlencoded",
        },
      }
    );

    if (res.data?.success) {
      toast.success("Refund successful");
      fetchCustomerDetails();
    } else {
      toast.error(res.data?.message || "Refund unsuccessful");
    }

  } catch (err) {
    toast.error(err.response?.data?.message || "Refund unsuccessful");
  } finally {
    setRefundLoading(false);
    setRefundModal(false);
    setSelectedRefundItem(null);
    setRefundAmount("");
  }
};

  return (
    <div>
      <Table className="align-items-center table-flush" responsive bordered hover>
        <thead className="thead-light">
          <tr>
            <th>Inst No</th>
            <th>Service</th>
            <th>Trans ID</th>
            <th>Trans Date</th>
            <th>Trans Amt</th>
            <th>Extra Amt</th>
            <th>Action</th>
            <th>Mode</th>
            <th>Refunded</th>
            <th>Settled</th>
            <th>Created</th>
            <th>Updated</th>
            {/* <th>Rollback</th>
            <th>Rollback Tab</th> */}
          </tr>
        </thead>
        <tbody>
          {/* {customerDetails.map((item, idx) => { */}
          {currentRows.map((item, idx) => {
            const isExpanded = expandedRowId === item.payment_id;
            const extraAmount = Number(item.extra_amount);
            const isRefunded = customerDetails.some(
  (p) =>
    p.tran_id === item.tran_id &&
    (p.tran_type === "REFUND" || p.tran_type === 2)
);
            // const isRolledBack = item.is_rollback === 1 || item.is_rollback === "Yes";
            // const showRollbackButton = item.payment_id === latestRollbackPaymentId;

            return (
              <React.Fragment key={item.payment_id}>
                <tr
                  onClick={() => toggleRow(item.payment_id)}
                  style={{ cursor: "pointer", backgroundColor: "#f8f9fe" }}
                >
                  <td>
                    <div style={{ display: "flex", alignItems: "center", gap: "6px" }}>
                      {/* <span>{idx + 1}</span> */}
                      <span>{indexOfFirstRow + idx + 1}</span>
                      <span style={{ fontSize: "14px" }}>{isExpanded ? "▼" : "▶"}</span>
                    </div>
                  </td>
                  {/* <td>{item.loan_id || lid}</td> */}
                  <td>{item.service || "-"}</td>
                  <td>{item.tran_id || "-"}</td>
                 <td>{formatDateTime(item.tran_date)}</td>
                  <td>{item.tran_amount || "-"}</td>
                  <td>{extraAmount > 0 ? `₹${extraAmount}` : "-"}</td>
                  <td>
                    {extraAmount > 0 && privilegeList.refundShow && (
                      <Button
                        size="sm"
                        color="danger"
                        disabled={isRefunded}
                        onClick={(e) => {
                          e.stopPropagation();
                          openRefundModal(item);
                        }}
                      >
                        {isRefunded ? "Refunded" : "Refund"}
                      </Button>
                    )}
                  </td>
                  <td>{item.mode || "-"}</td>
                  <td>{item.is_refunded || "-"}</td>
                  <td>{item.is_settled || "-"}</td>
                  <td>{formatDateTime(item.create_date)}</td>
                  <td>{formatDateTime(item.update_date)}</td>
                  {/* <td>{isRolledBack ? "Yes" : "No"}</td>
                  <td>
                    {showRollbackButton && (
                      <Button
                        color="danger"
                        size="sm"
                        onClick={(e) => {
                          e.stopPropagation();
                          openCommentModal("rollback", item);
                        }}
                      >
                        Rollback
                      </Button>
                    )}
                  </td> */}
                </tr>

                {isExpanded && (
                  <tr>
                    <td colSpan="14" style={{ padding: 0, backgroundColor: "#f0f4f8" }}>
                      <div style={{ padding: "10px 15px" }}>
                        {adjustmentData[item.payment_id]?.[0]?.message ? (
                          <div style={{ padding: "10px", color: "gray" }}>
                            {adjustmentData[item.payment_id][0].message}
                          </div>
                        ) : (
                          <Table bordered size="sm" style={{ backgroundColor: "#e2e8f0" }}>
                            <thead>
                              <tr>
                                <th>EMI No</th>
                                <th>Loan ID</th>
                                <th>Amount</th>
                                <th>Type</th>
                              </tr>
                            </thead>
                            <tbody>
                              {adjustmentData[item.payment_id]?.map((adj, i) => (
                                <tr key={i}>
                                  <td>{adj.emiNumber}</td>
                                  <td>{adj.loanId}</td>
                                  <td>{adj.amount}</td>
                                  <td>{adj.type}</td>
                                </tr>
                              ))}
                            </tbody>
                          </Table>
                        )}
                      </div>
                    </td>
                  </tr>
                )}
              </React.Fragment>
            );
          })}
        </tbody>
      </Table>

      {/* --- PAGINATION UI --- */}
      <div className="d-flex justify-content-center align-items-center mt-3" style={{ gap: "10px" }}>
        <Button 
          size="sm" 
          color="outline-primary" 
          disabled={currentPage === 1} 
          onClick={() => setCurrentPage(prev => prev - 1)}
        >
          Previous
        </Button>
        <span style={{ fontSize: "12px", fontWeight: "bold" }}>
          Page {currentPage} of {totalPages || 1}
        </span>
        <Button 
          size="sm" 
          color="outline-primary" 
          disabled={currentPage === totalPages || totalPages === 0} 
          onClick={() => setCurrentPage(prev => prev + 1)}
        >
          Next
        </Button>
      </div>

      {/* Comment Modal */}
      <Modal isOpen={commentModal} toggle={() => setCommentModal(false)}>
        <ModalHeader toggle={() => setCommentModal(false)}>
          {commentType === "rollback" ? "Rollback Payment" : "Apply Extra Amount"}
        </ModalHeader>
        <ModalBody>
          <FormGroup>
            <Label for="comment">Enter Comment</Label>
            <Input
              id="comment"
              type="textarea"
              value={userComment}
              onChange={(e) => setUserComment(e.target.value)}
              placeholder="Enter your comment here..."
            />
          </FormGroup>
        </ModalBody>
        <ModalFooter>
          <Button color="success" onClick={handleCommentSubmit}>
            Submit
          </Button>
          <Button color="secondary" onClick={() => setCommentModal(false)}>
            Cancel
          </Button>
        </ModalFooter>
      </Modal>
      <Modal isOpen={refundModal} toggle={() => setRefundModal(false)}>
  <ModalHeader toggle={() => setRefundModal(false)}>
    Refund Payment
  </ModalHeader>

  <ModalBody>



    <FormGroup>
      <Label>Amount</Label>
     <Input
  type="number"
  value={refundAmount}
  disabled
/>
    </FormGroup>

  </ModalBody>

  <ModalFooter>
    <Button color="success" onClick={handleRefundSubmit} disabled={refundLoading}>
      {refundLoading ? "Processing..." : "Submit"}
    </Button>
    <Button color="secondary" onClick={() => setRefundModal(false)} disabled={refundLoading}>
      Cancel
    </Button>
  </ModalFooter>
</Modal>
    </div>
  );
};

export default PaymentHistory;
